export const SET_SIDEBAR_SHOW = "SET_SIDEBAR_SHOW";

export const SET_AREA_NAME = "SET_AREA_NAME";